module.exports = __webpack_public_path__ + "static/media/3DR_old.a0a6b9e1.png";